export default class Cookie {
    static set(name, value, expiredays, path, domain, secure) {
        let expiresDate = new Date();
        expiresDate.setDate(expiresDate.getDate()+expiredays);
        document.cookie = name + "=" + escape( value ) +
            ( ( expiredays ) ? ";expires=" + expiresDate.toGMTString() : "" ) +
            ( ( path ) ? ";path=" + path : "/" ) +
            ( ( domain ) ? ";domain=" + domain : "" ) +
            ( ( secure ) ? ";secure" : "" );
    }

    static getValue(name) {
        let match = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
        return match ? unescape(match[2]) : null;
    }

    static destroy(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
}